import * as React from 'react';
import { useSelector } from 'react-redux';
import { useState } from 'react';

import { trackNavigateToDealForm } from '../../utils/analytics';
import { DealPriceCalculator, TCalculatorStages } from './components/DealPriceCalculator';
import { selectDealFormUrl } from '../../selectors/promoInfo/selectDealFormUrl';
import { makeFileNotCacheable } from '../../utils/makeFileNotCacheable';
import { useApplicationContext } from '../../utils/applicationContext';
import { IGetPromoCalculatorResponse } from '../../types/promoCalculator';

export interface IDealPriceCalculatorContainerProps {
  scrollToAdditionalServices(): void;
  promoCalculatorData: IGetPromoCalculatorResponse;
}
export const DealPriceCalculatorContainer: React.FC<IDealPriceCalculatorContainerProps> = props => {
  const { config } = useApplicationContext();
  const priceListUrl = makeFileNotCacheable(
    config.get<string>('deal-sale-promo-frontend.priceListUrl') || /* istanbul ignore next */ '',
  );
  const { scrollToAdditionalServices, promoCalculatorData } = props;
  const dealFormUrl = useSelector(selectDealFormUrl);

  const [calculatorIndexes, setCalculatorIndexes] = useState<TCalculatorStages>({
    dealLocations: 0,
    settlementMethods: 0,
    tariffs: 0,
  });

  const handleChange = (key: keyof TCalculatorStages, index: number) => {
    setCalculatorIndexes({
      ...calculatorIndexes,
      [key]: index,
    });
  };

  const onCreateDealButtonClick = () => {
    trackNavigateToDealForm('price');
  };

  return (
    <DealPriceCalculator
      dealFormUrl={dealFormUrl}
      priceListUrl={priceListUrl}
      scrollToAdditionalServices={scrollToAdditionalServices}
      onCreateDealButtonClick={onCreateDealButtonClick}
      handleChange={handleChange}
      calculatorIndexes={calculatorIndexes}
      {...promoCalculatorData}
    />
  );
};
